import SelectInput from 'components/inputs/SelectInput';
import PropTypes from 'prop-types';
import { forwardRef } from 'react';
import { COUNTRY_OPTIONS, DEFAULT_COUNTRY } from '../constants/countries';

const BillingCountryField = forwardRef(({ value, onChange, onBlur, name }, ref) => (
  <SelectInput
    ref={ref}
    name={name}
    enableSearch
    options={COUNTRY_OPTIONS}
    value={value || DEFAULT_COUNTRY}
    placeholder="Select country"
    onChange={(selectedValue) => {
      onChange(selectedValue || DEFAULT_COUNTRY);
    }}
    onBlur={onBlur}
  />
));

BillingCountryField.displayName = 'BillingCountryField';

BillingCountryField.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func,
  name: PropTypes.string,
};

export default BillingCountryField;
